(() => {
    document.addEventListener('DOMContentLoaded', function () {
        if (typeof productData === 'undefined') {
            return;
        }

        const type = document.getElementById('sowing_method');
        const area = document.getElementById('seed_area');
        const result = document.getElementById('seed_result');
        const priceEl = document.getElementById('seed_price');
        const qty = document.querySelector('form.cart input.qty');
        const pricePerKg = productData.pricePerKg;

        function updatePrice() {
            const quantity = parseFloat(qty.value) || 0;
            priceEl.textContent = (quantity * pricePerKg).toFixed(2);
        }

        function calculate() {
            const selected = type.options[type.selectedIndex];
            const germinationRate = parseFloat(selected.dataset.rate) || 0;
            const minimumOrder = parseFloat(selected.dataset.min) || 0;
            const areaValue = parseFloat(area.value) || 0;
            const kg = areaValue * germinationRate;
            const finalKg = Math.max(kg, minimumOrder);
            const roundedKg = Math.ceil(finalKg / 0.05) * 0.05;
            qty.value = roundedKg.toFixed(2);
            qty.dispatchEvent(new Event('change'));
            result.textContent = roundedKg.toFixed(2);
            updatePrice();
        }

        type.addEventListener('change', calculate);
        area.addEventListener('input', calculate);

        qty.addEventListener('input', updatePrice);
        qty.addEventListener('change', updatePrice);

        calculate();
    });
})();
